import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { SidebarMenuButton, SidebarMenuItem } from '@monksflow/monks-ui';

export interface AnalysisSidebarNavItemProps {
  icon: ReactNode;
  label: string;
  active?: boolean;
  onClick: () => void;
}

const itemVariants = {
  hidden: { opacity: 0, x: -12 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.4, ease: [0.4, 0, 0.2, 1] as const },
  },
};

/**
 * Section row for the redesigned rail. Mirrors the shared FeatureSidebar item's
 * entrance and active colouring.
 */
export const AnalysisSidebarNavItem = ({
  icon,
  label,
  active = false,
  onClick,
}: AnalysisSidebarNavItemProps) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <SidebarMenuItem>
      <motion.div
        variants={shouldReduceMotion ? undefined : itemVariants}
        initial={shouldReduceMotion ? false : undefined}
      >
        <SidebarMenuButton
          orientation="horizontal"
          isActive={active}
          onClick={onClick}
          aria-current={active ? 'page' : undefined}
          className="hover:bg-sidebar-accent/50 w-full cursor-pointer"
        >
          <span
            className={`mr-1 flex size-4 shrink-0 items-center justify-center ${
              active ? 'text-primary' : 'text-foreground-subtle'
            }`}
          >
            {icon}
          </span>
          <span className={active ? 'font-medium text-primary' : 'font-normal text-foreground'}>
            {label}
          </span>
        </SidebarMenuButton>
      </motion.div>
    </SidebarMenuItem>
  );
};
